export default __webpack_public_path__ + "static/media/fb-logo.704c685c.svg";